




import { Component, Mixins, Prop } from "vue-property-decorator";
import { Size } from "../../../domain/drawing";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class CursorKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop({ default: () => new Size(10, 10) })
  gridSize: Size;

  @Prop()
  moving: (offest: Size) => boolean;

  @Prop()
  moved: (offest: Size) => boolean;

  data() {
    return {
      lastPressedKeyCode: null as number,
      lastKeyPressedTime: 0,
      lastOffset: new Size(0, 0),
      timeOffset: 0,
    };
  }
  lastPressedKeyCode: number;
  lastKeyPressedTime: number;
  lastOffset: Size;
  timeOffset: number;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (isInputting) {
      return false;
    }
    const offset = this.toMoveOffset(event);
    if (!offset) {
      return false;
    }
    if ((this.lastPressedKeyCode === event.keyCode) && (event.timeStamp < (this.lastKeyPressedTime + 500))) {
      return true;  // キーリピートは間引く.(他で処理されても困るので処理はした事にする.)
    }
    const now = (new Date()).getTime();
    if (!this.lastPressedKeyCode) {
      this.timeOffset = now - event.timeStamp;
    }
    this.lastPressedKeyCode = event.keyCode;
    this.lastKeyPressedTime = event.timeStamp;
    this.lastOffset = this.lastOffset.add(offset);
    if ((now - this.timeOffset - event.timeStamp) < 1000) { // 処理が追いついてないと思しき時は、通知を更に間引く.
      return !!this.moving
          && this.moving(this.lastOffset);
    }
    return false;
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (isInputting) {
      return false;
    }
    const offset = this.toMoveOffset(event);
    if (!offset || (this.lastPressedKeyCode !== event.keyCode)) {
      return false;
    }
    const result = !!this.moved
                && this.moved(this.lastOffset);
    this.lastPressedKeyCode = null;
    this.lastKeyPressedTime = 0;
    this.lastOffset = new Size(0, 0);
    this.timeOffset = 0;
    return result;
  }

  private toMoveOffset(event: KeyboardEvent): Size {
    const unit = this.toUnit(event);
    if (event.keyCode === CursorKeyHandler._keyCodes.left) {
      return new Size(-unit.width, 0);
    } else if (event.keyCode === CursorKeyHandler._keyCodes.up) {
      return new Size(0, -unit.height);
    } else if (event.keyCode === CursorKeyHandler._keyCodes.right) {
      return new Size(unit.width, 0);
    } else if (event.keyCode === CursorKeyHandler._keyCodes.down) {
      return new Size(0, unit.height);
    }
    return null;
  }

  private static readonly _keyCodes = {
    left: 0x25,   // ArrowLeft.
    up: 0x26,     // ArrowUp.
    right: 0x27,  // ArrowRight.
    down: 0x28,   // ArrowDown,
  };

  private toUnit(event: KeyboardEvent): Size {
    return event.shiftKey
      ? new Size(1, 1)
      : this.gridSize;
  }
}
